<template>
  <CommonLayout>
    <el-row>
      <!-- 修改：调整列的宽度 -->
      <el-col :span="16"> 
        <div>
          <!-- 新增：请求类型文案 -->
          <!-- <span>请求类型</span> -->
          <el-form-item label="请求类型">
            <el-select v-model="selectedOption">
              <el-option label="获取通行密钥" value="accessKey"></el-option>
              <el-option label="文件上传" value="fileUpload"></el-option>
              <el-option label="文件下载" value="fileDownload"></el-option>
              <el-option label="文件路径查询" value="filePathQuery"></el-option>
              <el-option label="文件列表查询" value="fileListQuery"></el-option>
              <el-option label="文件删除" value="fileDelete"></el-option>
            </el-select>
          </el-form-item>
          
          <!-- 用一个框包裹左侧表单 -->
          <div class="form-wrapper">
            <el-form v-if="selectedOption === 'accessKey'">
              <el-form-item label="临时密钥">
                <el-input v-model="tmpToken" placeholder="请输入临时密钥"></el-input>
              </el-form-item>
              <el-form-item label="临时密码">
                <el-input v-model="secretKey" placeholder="请输入临时密码"></el-input>
              </el-form-item>
              <el-form-item>
                <!-- 修改：提交按钮使用 primary 样式 -->
                <el-button type="primary" @click="submitForm">提交</el-button>
                <el-button @click="resetForm">重置</el-button>
              </el-form-item>
            </el-form>
            <!-- 新增文件上传表单 -->
            <el-form v-if="selectedOption === 'fileUpload'" label-width="100px">
              <el-form-item label="文件">
                <el-upload
                  ref="uploadRef"
                  :action="fileUploadUrl"
                  method="post"
                  :data="{
                    accessKey: accessKeyUpload, // 去掉 .value
                    objectKey: objectKeyUpload, // 去掉 .value
                    availableFlag: availableFlag // 去掉 .value
                  }"
                  :show-file-list="true"
                  multiple
                  :limit="3"
                  :before-upload="beforeUpload"
                  @success="handleUploadSuccess"
                  @error="handleUploadError"
                  :auto-upload="false"
                  style="width: 100%;"
                >
                  <el-button type="primary">选择文件</el-button>
                </el-upload>
              </el-form-item>
              <el-form-item label="通行密钥">
                <el-input v-model="accessKeyUpload" placeholder="请输入通行密钥"></el-input> <!-- 修改为上传专用字段 -->
              </el-form-item>
              <el-form-item label="object密钥">
                <el-input v-model="objectKeyUpload" placeholder="请输入object密钥"></el-input> <!-- 修改为上传专用字段 -->
              </el-form-item>
              <el-form-item label="可访问标识">
                <el-select v-model="availableFlag">
                  <el-option label="限制访问" value="0"></el-option>
                  <el-option label="公开访问" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitFileUpload">提交</el-button>
                <el-button @click="resetFileUploadForm">重置</el-button>
              </el-form-item>
            </el-form>
            <!-- 新增文件下载表单 -->
            <el-form v-if="selectedOption === 'fileDownload'" label-width="100px">
              <el-form-item label="FOS文件ID">
                <el-input v-model="fosFileId" placeholder="请输入FOS文件ID"></el-input>
              </el-form-item>
              <el-form-item label="通行密钥">
                <el-input v-model="accessKeyDownload" placeholder="请输入通行密钥"></el-input> <!-- 修改为下载专用字段 -->
              </el-form-item>
              <el-form-item label="object密钥">
                <el-input v-model="objectKeyDownload" placeholder="请输入object密钥"></el-input> <!-- 修改为下载专用字段 -->
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitFileDownload">提交</el-button>
                <el-button @click="resetFileDownloadForm">重置</el-button>
              </el-form-item>
            </el-form>
            <!-- 新增文件路径查询表单 -->
            <el-form v-if="selectedOption === 'filePathQuery'" label-width="100px">
              <el-form-item label="通行密钥">
                <el-input v-model="accessKeyQuery" placeholder="请输入通行密钥"></el-input>
              </el-form-item>
              <el-form-item label="object密钥">
                <el-input v-model="objectKeyQuery" placeholder="请输入object密钥"></el-input>
              </el-form-item>
              <el-form-item label="FOS文件ID">
                <el-input v-model="fosFileIdQuery" placeholder="请输入FOS文件ID"></el-input>
              </el-form-item>
              <el-form-item label="图片操作">
                <el-select v-model="operationQuery">
                  <el-option label="无" value=""></el-option>
                  <el-option label="调整大小" value="resize"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="图片宽度">
                <el-input v-model="widthQuery" placeholder="请输入图片宽度（0 - 1000）" type="number" min="0" max="1000"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitFilePathQuery">提交</el-button>
                <el-button @click="resetFilePathQueryForm">重置</el-button>
              </el-form-item>
            </el-form>
            <!-- 新增文件列表查询表单 -->
            <el-form v-if="selectedOption === 'fileListQuery'" label-width="100px">
              <el-form-item label="通行密钥">
                <el-input v-model="accessKeyListQuery" placeholder="请输入通行密钥"></el-input>
              </el-form-item>
              <el-form-item label="object密钥">
                <el-input v-model="objectKeyListQuery" placeholder="请输入object密钥"></el-input>
              </el-form-item>
              <el-form-item label="文件名称">
                <el-input v-model="fosFileName" placeholder="请输入文件名称"></el-input>
              </el-form-item>
              <el-form-item label="文件类型">
                <el-input v-model="fosFileType" placeholder="请输入文件类型"></el-input>
              </el-form-item>
              <el-form-item label="可访问标识">
                <el-select v-model="availableFlagListQuery">
                  <el-option label="请选择访问标识" value=""></el-option>
                  <el-option label="限制访问" value="0"></el-option>
                  <el-option label="公开访问" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitFileListQuery">提交</el-button>
                <el-button @click="resetFileListQueryForm">重置</el-button>
              </el-form-item>
            </el-form>
            <!-- 新增文件删除表单，移到此处 -->
            <el-form v-if="selectedOption === 'fileDelete'" label-width="100px">
              <el-form-item label="通行密钥">
                <el-input v-model="accessKeyDelete" placeholder="请输入通行密钥"></el-input>
              </el-form-item>
              <el-form-item label="object密钥">
                <el-input v-model="objectKeyDelete" placeholder="请输入object密钥"></el-input>
              </el-form-item>
              <el-form-item label="FOS文件ID">
                <el-input v-model="fosFileIdDelete" placeholder="请输入FOS文件ID"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitFileDelete">提交</el-button>
                <el-button @click="resetFileDeleteForm">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-col>
      <el-col :span="8"></el-col>
    </el-row>
    <el-row>
      <el-col :span="16"> 
        <!-- 使用 div 来展示 JSON 数据 -->
        <div class="response-json" v-html="getFormattedResponse()"></div>
        <!-- 新增提示文案 -->
        <div class="data-update-tip">提示：使用调试工具可快速体验FOS提供的能力。</div>
      </el-col>
      <el-col :span="8"></el-col>
    </el-row>
  </CommonLayout>
</template>

<script setup>
import { ref } from 'vue';
import { API_CONFIG, getApiUrl } from '@/config/api';
import CommonLayout from '@/components/CommonLayout.vue';
import { generateToken } from '@/utils/crypto';
import service from '@/utils/http';

const selectedOption = ref('accessKey');
const tmpToken = ref('');
const secretKey = ref('');
const responseData = ref('服务端返回的数据');
const formattedResponseData = ref('服务端返回的数据');

// 新增文件上传相关数据
const uploadRef = ref(null);
const accessKeyUpload = ref(''); // 新增上传专用字段
const objectKeyUpload = ref(''); // 新增上传专用字段
const availableFlag = ref('0');
const fileUploadUrl = API_CONFIG.baseURL.concat(getApiUrl('fileUpload'));

// 新增文件下载相关数据
const fosFileId = ref('');
const accessKeyDownload = ref(''); // 新增下载专用字段
const objectKeyDownload = ref(''); // 新增下载专用字段

// 存储不同请求类型的最后一次响应结果
const lastResponses = ref({});

const submitForm = async () => {
  const timestamp = new Date().getTime().toString();
  // 根据实际情况生成加密字符串
  const token = generateToken({ 
    tmpToken: tmpToken.value, 
    secretKey: secretKey.value, 
    timestamp 
  }); 

  try {
    // 获取完整的请求地址
    const apiUrl = getApiUrl(selectedOption.value);
    const response = await service.get(apiUrl, {
      params: {
        tmpToken: tmpToken.value,
        secretKey: secretKey.value,
        timestamp,
        token
      }
    });
    responseData.value = JSON.stringify(response, null, 2);
    // 格式化 JSON 数据并添加换行符
    formattedResponseData.value = responseData.value.replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;');
    // 保存本次响应结果
    lastResponses.value[selectedOption.value] = formattedResponseData.value;
  } catch (error) {
    responseData.value = `Error: ${error.message}`;
    formattedResponseData.value = responseData.value.replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;');
    // 保存错误响应结果
    lastResponses.value[selectedOption.value] = formattedResponseData.value;
  }
};

const resetForm = () => {
  tmpToken.value = '';
  secretKey.value = '';
  responseData.value = '服务端返回的数据';
  formattedResponseData.value = '服务端返回的数据';
};

// 新增文件上传相关方法
const beforeUpload = (file) => {
  // 可以在这里添加文件上传前的验证逻辑
  return true;
};

const handleUploadSuccess = (response) => {
  responseData.value = JSON.stringify(response, null, 2);
  formattedResponseData.value = responseData.value.replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;');
  // 保存本次响应结果
  lastResponses.value[selectedOption.value] = formattedResponseData.value;
};

const handleUploadError = (error) => {
  responseData.value = `Error: ${error.message}`;
  formattedResponseData.value = responseData.value.replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;');
  // 保存错误响应结果
  lastResponses.value[selectedOption.value] = formattedResponseData.value;
};

const submitFileUpload = () => {
  uploadRef.value.submit();
};

const resetFileUploadForm = () => {
  accessKeyUpload.value = ''; // 重置上传专用字段
  objectKeyUpload.value = ''; // 重置上传专用字段
  availableFlag.value = '0';
  responseData.value = '服务端返回的数据';
  formattedResponseData.value = '服务端返回的数据';
  uploadRef.value.clearFiles(); // 清除已选择的文件
};

// 新增文件下载相关方法
const submitFileDownload = async () => {
  // 进行空判断
  if (!fosFileId.value || !accessKeyDownload.value || !objectKeyDownload.value) {
    responseData.value = 'Error: FOS文件ID、通行密钥和object密钥均为必填项';
    formattedResponseData.value = responseData.value.replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;');
    lastResponses.value[selectedOption.value] = formattedResponseData.value;
    return;
  }

  try {
    const apiUrl = getApiUrl(selectedOption.value);
    const fullUrl = `${API_CONFIG.baseURL}${apiUrl}?fosFileId=${fosFileId.value}&accessKey=${accessKeyDownload.value}&objectKey=${objectKeyDownload.value}`;

    const response = await fetch(fullUrl, {
      method: 'GET',
      headers: {
        'Accept': 'application/octet-stream' // 设置请求头，告知服务器期望接收二进制流
      }
    });

    if (response.ok) {
      const blob = await response.blob();
      const contentType = response.headers.get('Content-Type');
      let fileExtension = '';
      if (contentType === 'image/png') {
        fileExtension = '.png';
      } else if (contentType === 'application/pdf') {
        fileExtension = '.pdf';
      } 
      // 可以根据需要添加更多的文件类型判断

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `downloaded_file${fileExtension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      responseData.value = '文件已下载';
      formattedResponseData.value = responseData.value.replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;');
      lastResponses.value[selectedOption.value] = formattedResponseData.value;
    } else {
      const errorData = await response.text();
      responseData.value = `Error: ${errorData}`;
      formattedResponseData.value = responseData.value.replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;');
      lastResponses.value[selectedOption.value] = formattedResponseData.value;
    }
  } catch (error) {
    responseData.value = `Error: ${error.message}`;
    formattedResponseData.value = responseData.value.replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;');
    lastResponses.value[selectedOption.value] = formattedResponseData.value;
  }
};

const resetFileDownloadForm = () => {
  fosFileId.value = '';
  accessKeyDownload.value = ''; // 重置下载专用字段
  objectKeyDownload.value = ''; // 重置下载专用字段
  responseData.value = '服务端返回的数据';
  formattedResponseData.value = '服务端返回的数据';
};

// 根据当前请求类型获取格式化后的响应数据
const getFormattedResponse = () => {
  return lastResponses.value[selectedOption.value] || '服务端返回的数据';
};
// 新增文件路径查询相关数据
const accessKeyQuery = ref('');
const objectKeyQuery = ref('');
const fosFileIdQuery = ref('');
const operationQuery = ref('');
const widthQuery = ref('');

const submitFilePathQuery = async () => {
  try {
    const apiUrl = getApiUrl('filePath'); // 修改为 filePath
    const response = await service.get(apiUrl, {
      params: {
        accessKey: accessKeyQuery.value,
        objectKey: objectKeyQuery.value,
        fosFileId: fosFileIdQuery.value,
        operation: operationQuery.value,
        width: widthQuery.value
      }
    });

    // 输出原始响应数据，用于排查问题
    console.log('原始响应数据:', response.data);
    responseData.value = JSON.stringify(response, null, 2);

    // 修改：使用正则表达式替换所有的 & 为 &amp;
    formattedResponseData.value = responseData.value.replace(/&/g, '&amp;').replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;');
    lastResponses.value[selectedOption.value] = formattedResponseData.value;
  } catch (error) {
    responseData.value = `Error: ${error.message}`;
    formattedResponseData.value = responseData.value.replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;');
    lastResponses.value[selectedOption.value] = formattedResponseData.value;
  }
};

const resetFilePathQueryForm = () => {
  accessKeyQuery.value = '';
  objectKeyQuery.value = '';
  fosFileIdQuery.value = '';
  operationQuery.value = '';
  widthQuery.value = '';
  responseData.value = '服务端返回的数据';
  formattedResponseData.value = '服务端返回的数据';
};
// 新增文件列表查询相关数据
const accessKeyListQuery = ref('');
const objectKeyListQuery = ref('');
const fosFileName = ref('');
const fosFileType = ref('');
// 修改默认值为空字符串
const availableFlagListQuery = ref(''); 

const submitFileListQuery = async () => {
  try {
    const apiUrl = getApiUrl('fileList');
    // 构建请求参数对象
    const params = {
      accessKey: accessKeyListQuery.value,
      objectKey: objectKeyListQuery.value
    };

    // 检查文件名称是否不为空
    if (fosFileName.value.trim()!== '') {
      params.fosFileName = fosFileName.value;
    }

    // 检查文件类型是否不为空
    if (fosFileType.value.trim()!== '') {
      params.fosFileType = fosFileType.value;
    }

    // 若 availableFlagListQuery 不为空则添加到请求参数中
    if (availableFlagListQuery.value) {
      params.availableFlag = availableFlagListQuery.value;
    }

    const response = await service.get(apiUrl, {
      params
    });
    responseData.value = JSON.stringify(response, null, 2);
    // 格式化 JSON 数据并添加换行符
    formattedResponseData.value = responseData.value.replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;');
    // 保存本次响应结果
    lastResponses.value[selectedOption.value] = formattedResponseData.value;
  } catch (error) {
    responseData.value = `Error: ${error.message}`;
    formattedResponseData.value = responseData.value.replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;');
    // 保存错误响应结果
    lastResponses.value[selectedOption.value] = formattedResponseData.value;
  }
};

const resetFileListQueryForm = () => {
  accessKeyListQuery.value = '';
  objectKeyListQuery.value = '';
  fosFileName.value = '';
  fosFileType.value = '';
  availableFlagListQuery.value = '0';
  responseData.value = '服务端返回的数据';
  formattedResponseData.value = '服务端返回的数据';
};

// 新增文件删除相关数据
const accessKeyDelete = ref('');
const objectKeyDelete = ref('');
const fosFileIdDelete = ref('');

// 新增文件删除提交方法
const submitFileDelete = async () => {
  try {
    const apiUrl = getApiUrl('fileDelete');
    // 修改为 POST 请求，移除 token 和 timestamp 参数
    const response = await service.post(apiUrl, {
      accessKey: accessKeyDelete.value,
      objectKey: objectKeyDelete.value,
      fosFileId: fosFileIdDelete.value
    });
    responseData.value = JSON.stringify(response, null, 2);
    // 格式化 JSON 数据并添加换行符
    formattedResponseData.value = responseData.value.replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;');
    // 保存本次响应结果
    lastResponses.value[selectedOption.value] = formattedResponseData.value;
  } catch (error) {
    responseData.value = `Error: ${error.message}`;
    formattedResponseData.value = responseData.value.replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;');
    // 保存错误响应结果
    lastResponses.value[selectedOption.value] = formattedResponseData.value;
  }
};

// 新增文件删除重置表单方法
const resetFileDeleteForm = () => {
  accessKeyDelete.value = '';
  objectKeyDelete.value = '';
  fosFileIdDelete.value = '';
  responseData.value = '服务端返回的数据';
  formattedResponseData.value = '服务端返回的数据';
};
</script>

<style scoped>
/* 修改：调整左右两块区域的 margin 以避免出现横向滚动条 */
.el-col {
  padding: 20px; 
  width: 50%; /* 宽度减半，减去左右 margin 的值 */
  box-sizing: border-box; /* 确保内边距和边框包含在宽度内 */
}

/* 左侧表单框样式 */
.form-wrapper {
  border: 1px solid #ccc; /* 框的边框 */
  border-radius: 4px; /* 框的圆角 */
  padding: 20px; /* 框内的内边距 */
  margin-top: 20px; /* 与下拉框的上边距 */
}

/* 右侧 JSON 显示区域样式 */
.response-json {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 20px;
  min-height: 300px; /* 增加高度 */
  white-space: pre-wrap;
  word-wrap: break-word;
}

/* 新增提示文案样式 */
.data-update-tip {
  color: red; 
  font-size: 12px; 
  margin-top: 10px; 
}
</style>
